import { render, staticRenderFns } from "./nguoinhan-component.vue?vue&type=template&id=7f51a1e4&scoped=true"
import script from "./nguoinhan-component.vue?vue&type=script&lang=js"
export * from "./nguoinhan-component.vue?vue&type=script&lang=js"
import style0 from "./nguoinhan-component.vue?vue&type=style&index=0&id=7f51a1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f51a1e4",
  null
  
)

export default component.exports